document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.questions__group .questions__item');
  
    if (accordionItems) {
      accordionItems.forEach((item) => {
        const accordionHeader = item.querySelector('.questions__header');
  
        if (accordionHeader) {
          accordionHeader.addEventListener('click', () => {
            const openItem = document.querySelector('.accordion-open');
    
            toggleItem(item);
    
            if (openItem && openItem !== item) {
              toggleItem(openItem);
            }
          })
        }
      })
    }

    // toggle function()
    const toggleItem = (item) => {
      const accordionContent = item.querySelector('.questions__content');
      const plusIcon = item.querySelector('.icon-plus');
      const minusIcon = item.querySelector('.icon-minus');

      if (item.classList.contains('accordion-open')) {
        accordionContent.removeAttribute('style');
        item.classList.remove('accordion-open');
        minusIcon.classList.add('hidden');
        plusIcon.classList.remove('hidden');
      } else {
        accordionContent.style.height = accordionContent.scrollHeight + 'px';
        item.classList.add('accordion-open');
        minusIcon.classList.remove('hidden');
        plusIcon.classList.add('hidden');
      }
    }

    // search filter
    const searchInput = document.querySelector('.search-bar');
    const items = document.querySelectorAll('.questions__item');
    const clearBtn = document.querySelector('.search-box-wrapper #js-clear');

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = searchInput.value.toLowerCase();
  
        items.forEach(function(item) {
          const title = item.querySelector('.questions__item-title').textContent.toLowerCase();
  
          if (title.includes(query)) {
            item.classList.remove('hidden');
          } else {
            item.classList.add('hidden');
          }
        });
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function() {
          searchInput.value = '';
          items.forEach(function(item) {
            item.classList.remove('hidden');
          });
        });
      }
    }
});